module.exports = __webpack_public_path__ + "img/Paso 5.f6199951.png";